module.exports = __webpack_public_path__ + "img/ico-lamp.45468ee6.svg";